import { faExclamationTriangle } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import cx from 'classnames';
import get from 'lodash/get';
import PropTypes from 'prop-types';
import React, { useState, useEffect } from 'react';
import { useFormContext } from 'react-hook-form';

import styles from './error-display.module.scss';
export default function SingleErrorDisplay({ field, className }) {
  const { formState } = useFormContext();
  const [screenreaderError, setScreenReaderError] = useState(null);

  let arrayError;
  let error = get(formState.errors, field);

  if (error?.length >= 1) {
    arrayError = error.filter((m) => m?.message);
    error = arrayError[0];
  }
  useEffect(() => {
    if (error?.message) {
      const timer = setTimeout(() => {
        setScreenReaderError(error.message);
      }, 1500);
      return () => clearTimeout(timer);
    } else {
      // TODO CCRA-37242
      setScreenReaderError(null);
    }
  }, [error?.message]);
  return (
    <div
      className={cx('d-flex align-items-center', className, styles.display)}
      tabIndex={error?.message ? 0 : -1}
      id={`${name}-error`}
    >
      {error?.message ? (
        <>
          <FontAwesomeIcon
            icon={faExclamationTriangle}
            size="sm"
            aria-hidden={true}
            className="me-1"
          />
          <small className="fw-bold" aria-hidden={true}>
            {error?.message}
          </small>
          {screenreaderError && (
            <div
              role="alert"
              aria-atomic={true}
              aria-live="assertive"
              className="sr-only"
            >
              {screenreaderError}
            </div>
          )}
        </>
      ) : null}
    </div>
  );
}

SingleErrorDisplay.propTypes = {
  field: PropTypes.string.isRequired,
  className: PropTypes.string,
};
